import { AgentCommon } from '~/agents/common/common/agent'

export const BlogWriterAgentCommon: AgentCommon = {
  key: 'contentCreator',
  hasOnboarding: true,
  hasSettings: true,
  guidelines: [
    {
      label: 'Writing Style',
      tag: 'content',
      suggestions: [
        'Use a friendly and approachable tone',
        'Keep paragraphs short and readable',
        'Avoid jargon and complex terms',
        'Use active voice when possible',
        'Always include a call to action',
        'Write in first person when appropriate',
        'Use bullet points for lists',
        'Avoid clickbait headlines',
        'Link to sources when referencing facts',
        'Keep intros concise',
        'End with a summary or takeaway',
        'Use contractions to sound natural',
        `Write like you're talking to a smart friend`,
        'Double-check spelling and grammar',
        'Include 1-2 relevant quotes if possible',
        'Break up content with headings',
        'Avoid passive-aggressive language',
        'Use consistent tense throughout',
        'Avoid overusing emojis',
        'Stay within the preferred word count (e.g. 500-700 words)',
      ],
    },
    {
      label: 'Image Style',
      tag: 'image',
      suggestions: [
        'Ensure text overlays are legible on all devices',
        'Use images that are relevant to the accompanying text',
        `Ensure images are culturally sensitive and inclusive`,
        `Highlight products or services in use`,
        `Use images to tell a story or convey a message`,
        `Use images that evoke emotion or action`,
        `Keep designs uncluttered and focused`,
        'Keep visual hierarchy clear',
        `Don't crowd multiple elements into one image`,
      ],
    },
  ],
}
